import React from 'react'

import Modal from "react-modal";
import "./css/Modais.css";
import "./css/ModaisMobile.css";
import "./css/Images.css";

export default function ModalConsumoMinimo({ isOpen, onRequestClose, recipient='Usuario A' }) {


  return (
  <Modal
    isOpen={isOpen}
    onRequestClose={onRequestClose}
    contentLabel="Modal"
    style={{ outline: 0 }}
    ariaHideApp={false}
    className={{
      base: "modal-base",
      afterOpen: "modal-base_after-open",
      beforeClose: "modal-base_before-close"
    }}
    overlayClassName={{
      base: "overlay-base",
      afterOpen: "overlay-base_after-open",
      beforeClose: "overlay-base_before-close"
    }}
    shouldCloseOnOverlayClick={true}
  >

  <div className="modal-close"  onClick={onRequestClose}></div>
  <div className="modal-imgCheck"></div>
  <div className="modal-text-secundario">Você não possui consumo suficiente para se tornar nosso cliente ainda</div>
  <button className="button-modal" onClick={onRequestClose}>Voltar</button>
  <div className="modal-text-terce">*A simulação considera consumidores (B1), ligação bifásica, conectados em baixa tensão.</div>

  </Modal>
  )
}